module.exports = __webpack_public_path__ + "files/06ecc346cd7695d78b4ad4633e7ca54a.png";